var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStackoverflowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#stackoverflow_icon_svg__clip0_768:2358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.58 19.85v-5.836h1.941v7.774H0v-7.774h1.941v5.837H15.58z",
    fill: "#BCBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.084 13.46l9.53 1.988.403-1.912-9.53-1.988-.403 1.912zm1.261-4.528l8.823 4.1.807-1.76-8.823-4.127-.807 1.787zM7.79 4.604l7.488 6.215 1.235-1.485L9.026 3.12 7.79 4.604zM12.63 0l-1.562 1.157 5.798 7.8 1.563-1.158L12.63 0zM3.884 17.889h9.73V15.95h-9.73v1.938z",
    fill: "#F48024"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "stackoverflow_icon_svg__clip0_768:2358"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18.526v22H0z"
  })))));
}

export default SvgStackoverflowIcon;